import ChainCard from './ChainCard';

export default ChainCard;
